<style scoped>
.replace-label{
	font-weight: bold;
}

.order-main .order-info{
	border-top:1px solid #ddd;
  padding: 20px 50px;
	position: relative;
}

.order-main .order-info table{
	border: none;
	display: inline;
  vertical-align: top;
}

.order-main .order-info table>tbody>tr>td{
	padding: 0 5px;
	height: 25px;
	border: none;
}

.order-main .order-info table>thead>tr>td{
	border-bottom: none;
}
.preview-order .info-list>p>.bold{
	font-weight: bold;
}

.order-main .order-info .list-absolute{
	position: absolute;
  left: 60%;
  top: 45px;
}

</style>

<template>
	    <section class="order-main preview-order">
        <div class="content" v-if="hotel.I">
            <div class="hotel-name">
                Hotel Confirmation <span>CN TRAVEL GROUP</span>
                <div class="logo"><img src="./../../assets/images/logo1.png" alt=""></div>
								<div class="small-title">{{hotel.I.EnHotelName}}</div>
								
            </div>
            <div class="order-info">
                <div class="info-list">
                    <p ><label class="replace-label">Booking No.：</label>
                    	<span>
		            				{{hotel.I.PurchaseOrderId}}
		            				<label >({{hotel.I.OrderType=='新单'?'New':hotel.I.OrderType=='变更单'?'Amend':hotel.I.OrderType=='取消单'?'Cancel':hotel.I.OrderType=='无效单'?'Invalid':''}})</label>
			        				</span>
		            		</p>
                    <p><label class="replace-label">Guest Name：</label>{{hotel['I'].GuestName}}</p>
										<p><label class="replace-label">Stay Period：</label>{{hotel['I'].CheckIn|delUTC|dateToDvd}} - {{hotel['I'].CheckOut|delUTC|dateToDvd}} <span class="bold">	（{{getDaysSize(hotel['I'].CheckIn,hotel['I'].CheckOut)}} night）</span></p>
										<p><label class="replace-label">Total Room Night(s)：</label><span class="bold">{{getDaysSize(hotel['I'].CheckIn,hotel['I'].CheckOut)*hotel['I'].RoomNum}}</span></p>
										<p><label class="replace-label">Room Type：</label><span class="font-18 color-red">{{hotel['I'].EnRoomName}} <span class="bold">（{{hotel['I'].RoomNum}} room）</span></span></p>
										<p><label class="replace-label">Requirements：</label><span class="color-red">{{hotel['I'].Notes||'none'}}</span></p>
										<p>
											<label class="replace-label">Rate Information：</label>
											<table cellspacing="0">
												<tbody>
													<tr v-for="price in hotel.P">
															<td>{{price.CheckIn|delUTC|dateToLineDvd}} ({{price.CheckIn|delUTC|dateWeek}})</td>
															<td>Base Price {{price.BaseCurrency}}{{price.BasePrice}}</td>
															<td>{{price.EnBreakfastName}}</td>
													</tr>
												</tbody>
											</table>
										</p>


										<p>
											<label class="replace-label">Surcharge information：</label>
											<table cellspacing="0">
												<tbody>
													<tr v-for="overcase in hotel.S" v-if="hotel.S&&hotel.S.length>0">
															<td>{{overcase.SurchargeDate|delUTC|dateToLineDvd}}</td>
															<td>{{overcase.SurchargeTypeName}}（{{overcase.SurchargeName}}）</td>
															<td>{{overcase.BaseCurrency}}{{overcase.BasePrice}}</td>
															<td>{{overcase.SurchargeNum}} price</td>
													</tr>
													<tr v-if="!hotel.S||hotel.S.length<=0">
															<td>none</td>
													</tr>
												</tbody>
											</table>
										</p>
										<p><label class="replace-label">Total：</label><span class="font-18 color-red">{{hotel['I'].Currency}} {{hotel['I'].TotalPrice}}</span> （ Prepay ）</p>
										<p><label class="replace-label">Remark：</label>{{hotel['I'].ConfirmRemark||'none'}}</p>
										<p><label class="replace-label">Booking maker：</label>{{hotel['I'].RealName}}（phone：{{hotel['I'].Phone||'none'}}   fax：{{hotel['I'].Fax||'none'}}）</p>
                </div>
		        			
									<div class="info-list list-absolute">
										<p><label class="replace-label">Confirmed result：</label>{{hotel['I'].ConfirmResult}}</p>
										<p><label class="replace-label">Verifier：</label>{{hotel['I'].Operator}}</p>
                    <p><label class="replace-label">Conf. No.：</label>{{hotel['I'].ConfirmNo||'none'}}</p>
									</div>
                
									<div class="print-comfir-box">
										<div class="print-confirm-btn not-print" @click="PrintOrder">Print</div> 
										<a  class="print-back-btn not-print" onclick="window.history.go(-1)">return</a>
									</div>
                                     
            </div>
        </div> 
    </section>
		
</template>
<script>
export default {
	name:"orderPrint",
	data(){
		return{
	    	ebID:this.dao.get('ebID'),
	    	VerCol:this.dao.get('VerCol'),
	    	hotel:''
		}
	},
	methods:{
  		initData () {
	        var that=this;
	        var params={
	            ebID: that.ebID,
	            ver: that.VerCol
	        }
	        that.isLoading=true;
	        that.getRequest({
	            url: that.Api.getOrderList,
	            params: params
	        }).then(res => {
	           that.isLoading=false;
	            if (res) {
	                that.hotel=res;
	            } else {
	                that.hotel='';
	                that.error({ title: 'Tips', content: 'No data is queried' });
	            }
	        });
	    },
  		
	    PrintOrder() {   
		   // var bdhtml=window.document.body.innerHTML;   
		   // var sprnstr="<!--startprint-->";   
		   // var eprnstr="<!--endprint-->";   
		   // var prnhtml=bdhtml.substr(bdhtml.indexOf(sprnstr)+17);   
		   //  prnhtml=prnhtml.substring(0,prnhtml.indexOf(eprnstr)); 
		   //  console.log(prnhtml);  
		   //  window.document.body.innerHTML=prnhtml;  
		    window.print();   
		},
	
		
	},
	mounted(){
		this.initData();
	}
}

	
</script>


// WEBPACK FOOTER //
// src/components/order/OrderPrint.vue